import SearchResultsMenu from "./SearchResultsMenu";

export default SearchResultsMenu;
